import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Search, Filter, Star, ShieldCheck, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
const networkData = [{
  id: 1,
  name: 'Sarah Jenkins',
  role: 'Medical Lead',
  score: 98,
  events: 24,
  location: 'San Francisco, CA',
  skills: ['Medical', 'Leadership']
}, {
  id: 2,
  name: 'Marcus Chen',
  role: 'Logistics Expert',
  score: 95,
  events: 18,
  location: 'Oakland, CA',
  skills: ['Logistics', 'Heavy Lifting']
}, {
  id: 3,
  name: 'Elena Rodriguez',
  role: 'Course Marshal',
  score: 92,
  events: 12,
  location: 'San Jose, CA',
  skills: ['Crowd Control', 'Bilingual']
}, {
  id: 4,
  name: 'David Kim',
  role: 'Registration Staff',
  score: 88,
  events: 8,
  location: 'San Francisco, CA',
  skills: ['Customer Service', 'Tech Savvy']
}, {
  id: 5,
  name: 'Aisha Patel',
  role: 'Volunteer Captain',
  score: 96,
  events: 21,
  location: 'Berkeley, CA',
  skills: ['Management', 'Training']
}, {
  id: 6,
  name: 'Tom Wilson',
  role: 'Media Liaison',
  score: 90,
  events: 15,
  location: 'San Francisco, CA',
  skills: ['Photography', 'Press Relations']
}, {
  id: 7,
  name: 'Jessica Lee',
  role: 'Water Station Lead',
  score: 94,
  events: 19,
  location: 'San Mateo, CA',
  skills: ['Organization', 'High Energy']
}, {
  id: 8,
  name: 'Robert Taylor',
  role: 'Traffic Control',
  score: 89,
  events: 11,
  location: 'Oakland, CA',
  skills: ['Traffic Management', 'Safety']
}];
export function Network() {
  const [searchTerm, setSearchTerm] = useState('');
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} className="space-y-6" data-id="element-473">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-474">
        <div data-id="element-475">
          <h1 className="text-2xl font-display font-bold text-white mb-1" data-id="element-476">
            Talent Network
          </h1>
          <p className="text-[var(--muted)] text-sm" data-id="element-477">
            Discover and connect with verified event professionals.
          </p>
        </div>
      </div>

      {/* Toolbar */}
      <div className="bg-[var(--surface)] border border-white/5 rounded-xl p-4 flex flex-col sm:flex-row gap-4 justify-between items-center" data-id="element-478">
        <div className="relative w-full sm:w-96" data-id="element-479">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[var(--muted)]" data-id="element-480" />
          <input type="text" placeholder="Search by name, role, or skill..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full bg-[var(--bg)] border border-white/10 rounded-md pl-9 pr-4 py-2 text-sm text-white focus:outline-none focus:border-[var(--accent)]/50 transition-colors placeholder:text-[var(--muted)]" data-id="element-481" />
        </div>
        <div className="flex items-center gap-3 w-full sm:w-auto" data-id="element-482">
          <select className="bg-[var(--bg)] border border-white/10 rounded-md px-3 py-2 text-sm text-white focus:outline-none focus:border-[var(--accent)]/50" data-id="element-483">
            <option data-id="element-484">All Roles</option>
            <option data-id="element-485">Medical</option>
            <option data-id="element-486">Logistics</option>
            <option data-id="element-487">Course Marshal</option>
          </select>
          <button className="flex items-center gap-2 px-3 py-2 border border-white/10 rounded-md text-sm text-[var(--muted)] hover:text-white hover:bg-white/5 transition-colors" data-id="element-488">
            <Filter className="w-4 h-4" data-id="element-489" />
            More Filters
          </button>
        </div>
      </div>

      {/* Network Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4" data-id="element-490">
        {networkData.map((person, i) => <Link to={`/dashboard/volunteers/${person.id}`} key={person.id} data-id="element-491">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: i * 0.05
        }} className="bg-[var(--surface)] border border-white/5 rounded-xl p-5 hover:border-[var(--accent)]/30 transition-all hover:shadow-[0_0_20px_rgba(200,255,60,0.05)] group cursor-pointer h-full flex flex-col" data-id="element-492">
              <div className="flex justify-between items-start mb-4" data-id="element-493">
                <div className="w-12 h-12 rounded-full bg-gradient-to-tr from-[var(--accent)] to-emerald-400 p-0.5" data-id="element-494">
                  <div className="w-full h-full bg-[var(--surface)] rounded-full flex items-center justify-center text-lg font-display font-bold text-white" data-id="element-495">
                    {person.name.charAt(0)}
                  </div>
                </div>
                <div className="flex items-center gap-1 bg-[var(--accent)]/10 px-2 py-1 rounded-md" data-id="element-496">
                  <Star className="w-3.5 h-3.5 text-[var(--accent)] fill-[var(--accent)]" data-id="element-497" />
                  <span className="text-xs font-bold text-[var(--accent)]" data-id="element-498">
                    {person.score}
                  </span>
                </div>
              </div>

              <div className="mb-4 flex-1" data-id="element-499">
                <h3 className="text-white font-medium flex items-center gap-1.5 group-hover:text-[var(--accent)] transition-colors" data-id="element-500">
                  {person.name}
                  <ShieldCheck className="w-4 h-4 text-[var(--accent)]" data-id="element-501" />
                </h3>
                <p className="text-sm text-[var(--muted)]" data-id="element-502">{person.role}</p>
                <div className="flex items-center gap-1 text-xs text-[var(--muted)] mt-2" data-id="element-503">
                  <MapPin className="w-3 h-3" data-id="element-504" />
                  {person.location}
                </div>
              </div>

              <div className="border-t border-white/5 pt-4 mt-auto" data-id="element-505">
                <div className="flex flex-wrap gap-1.5 mb-3" data-id="element-506">
                  {person.skills.map(skill => <span key={skill} className="text-[10px] font-medium px-2 py-1 bg-white/5 rounded-md text-[var(--muted)]" data-id="element-507">
                      {skill}
                    </span>)}
                </div>
                <div className="text-xs text-[var(--muted)] flex justify-between items-center" data-id="element-508">
                  <span data-id="element-509">{person.events} Events Completed</span>
                </div>
              </div>
            </motion.div>
          </Link>)}
      </div>
    </motion.div>;
}